import {
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  css,
  position,
  PositionProps,
  typography,
  TypographyProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { textDecoration, TextDecorationProps } from '../../textDecoration'
import {
  textTransform,
  TextTransformProps,
  TypoSizeProps,
  typoSizes,
} from '../typography'
import { Anchor, AnchorProps } from './Anchor'
import { hoverColor, HoverColorProps } from './hoverColor'

export type LinkAnchorProperty = 'standalone' | 'inline' | 'inverted'

export type LinkAnchorProps = Omit<
  AnchorProps &
    TypoSizeProps &
    TextDecorationProps &
    BorderProps &
    TypographyProps &
    ColorProps &
    TextTransformProps &
    PositionProps &
    HoverColorProps,
  'ref'
> & {
  variant?: LinkAnchorProperty
}

const defaultProps = withDefaultProps<LinkAnchorProps>({
  variant: 'inline',
})

export const LinkAnchor = styled(Anchor).attrs<LinkAnchorProps>(defaultProps)(
  css({
    display: 'inline-block',
    fontWeight: 'bold',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    fontFamily: 'buttons',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }),
  (props) =>
    props.disabled
      ? {
          opacity: 0.35,
          cursor: 'not-allowed',
        }
      : {},
  variant({
    scale: 'LinkAnchor',
    variants: {
      standalone: {
        color: 'hyperlink',
        borderColor: 'hyperlink',
        '&:hover': {
          color: 'primaryAccent',
          borderColor: 'primaryAccent',
        },
      },
      inverted: {
        color: 'chalk',
        borderColor: 'chalk',
        '&:hover': {
          color: 'hover',
          borderColor: 'hover',
        },
      },
      inline: {
        '&:hover': {
          color: 'primaryAccent',
          borderColor: 'primaryAccent',
        },
      },
    },
  }),
  compose(
    typoSizes,
    textDecoration,
    border,
    typography,
    color,
    textTransform,
    position,
    hoverColor,
  ),
)
